import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/api/query-keys";
import type { PaginatedResponse } from "@/api/types";
import { api } from "@/lib/api";
import type { AlertParams, MeterAlert } from "./types";

export function useAlertLog(
	params: AlertParams,
): UseQueryResult<PaginatedResponse<MeterAlert>, Error> {
	const cleanParams = Object.fromEntries(
		Object.entries(params).filter(([, v]) => v != null && v !== ""),
	);
	return useQuery({
		queryKey: queryKeys.districts.alertLog(cleanParams),
		queryFn: async (): Promise<PaginatedResponse<MeterAlert>> => {
			const res = await api.get<PaginatedResponse<MeterAlert>>(
				"/api/districts/alert_log/",
				{ params: cleanParams },
			);
			return res.data;
		},
	});
}
